import React, { useState, useEffect, useRef } from 'react';
import { Select, Image, Popover } from 'antd';
import PlaneDetails from './planes/PlaneDetails';
import ShipDetails from './ships/ShipDetails';
import EventDetails from './events/EventDetails';
import TargetDetails from './targets/TargetDetails';
import PersonDetails from './person/PersonDetails';
import profile from '../images/profile-circle.png'
import search from '../images/Union.png'
import { useNavigate } from 'react-router-dom';
import Icon from "@ant-design/icons";

const EarthHeader = (props) => {
    const [isPlaneModalOpen, setIsPlaneModalOpen] = useState(false)
    const [isShipModalOpen, setIsShipModalOpen] = useState(false)
    const [isEventModalOpen, setIsEventModalOpen] = useState(false)
    const [isTargetModalOpen, setIsTargetModalOpen] = useState(false)
    const [isPersonModalOpen, setIsPersonModalOpen] = useState(false)

    const planeListRef = useRef([])
    const shipListRef = useRef([])
    const eventListRef = useRef([])
    const targetListRef = useRef([])

    const [plane, setPlane] = useState(null)
    const [ship, setShip] = useState(null)
    const [event, setEvent] = useState(null)
    const [target, setTarget] = useState(null)
    const [person, setPerson] = useState(null)

    const navigate = useNavigate();

    useEffect(() => {
        planeListRef.current = props.planes
        shipListRef.current = props.ships
        eventListRef.current = props.events
        targetListRef.current = props.targets
    }, [props.planes, props.ships, props.events, props.targets])

    const handlePersonModalShow = () => {
        setIsPersonModalOpen(!isPersonModalOpen)
    }

    const handlePlaneModalShow = () => {
        setIsPlaneModalOpen(!isPlaneModalOpen)
    }
    const handleShipModalShow = () => {
        setIsShipModalOpen(!isShipModalOpen)
    }

    const handleEventModalShow = () => {
        setIsEventModalOpen(!isEventModalOpen)
    }

    const handleTargetModalShow = () => {
        setIsTargetModalOpen(!isTargetModalOpen)
    }

    const onChange = (value, option) => {
        switch(option.type) {
            case 'ship': 
                handleShipModalShow()
                setShip(option.ship)
                break
            case 'plane':
                handlePlaneModalShow()
                setPlane(option.plane)
                break
            case 'event':
                handleEventModalShow()
                setEvent(option.event)
                break
            case 'people':
                handlePersonModalShow()
                setPerson(option)
                break
            case 'target':
                handleTargetModalShow()
                setTarget(option.target)
                break
            default:
                break
        }
    };
    const onSearch = (value) => {
        console.log('search:', value);
    };

    const handleLogout = () => {
        props.setToken(null)
    }

    const goToSubPage = () => {
        navigate('/subscribe/ships');
    }

    const content = (
        <div className='popover'>
            <p className='item' onClick={goToSubPage}>订阅中心</p>
            <p className='item' onClick={handleLogout}>退出登录</p>
        </div>
    );

    const searchIcon = () => (
        <Image src={search} preview={false}/>
    )
    
    return(
        <div className='site-page-header'>
            <div className="logo-style">OsintFusion</div>
            <span className='nav' onClick={props.handleShipDrawerShow}>舰船列表</span>
            <span className='nav' onClick={props.handlePlaneDrawerShow}>飞机列表</span>
            <span className='nav' onClick={props.handleEventDrawerShow}>热点事件</span>
            <span className='nav' onClick={props.handlePersonDrawerShow}>重要人物</span>
            <span className='nav' onClick={props.handleTargetDrawerShow}>设施目标</span>
            <div className='search-all'>
                <Select
                    showSearch
                    showArrow={true}
                    allowClear
                    placeholder="请输入关键词"
                    optionFilterProp="children"
                    onChange={onChange}
                    onSearch={onSearch}
                    filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    options={props.combinedItems}
                    suffixIcon={<Icon component={searchIcon}/>}
                />
                <Popover placement="bottom" content={content} trigger="click">
                    <Image
                        className='profile'
                        preview={false}
                        src={profile}
                    />
                </Popover>
            </div>
            {
                isPlaneModalOpen ?
                <PlaneDetails isModalOpen={isPlaneModalOpen} plane={plane} handleModalShow={handlePlaneModalShow}/> : ''
            }
            {
                isShipModalOpen ?
                <ShipDetails isModalOpen={isShipModalOpen} ship={ship} handleModalShow={handleShipModalShow}/> : ''
            }
            {
                isEventModalOpen ?
                <EventDetails isModalOpen={isEventModalOpen} event={event} handleModalShow={handleEventModalShow}/> : ''

            }
            {
                isTargetModalOpen ?
                <TargetDetails isModalOpen={isTargetModalOpen} target={target} handleModalShow={handleTargetModalShow}/> : ''
            }
            {
                isPersonModalOpen ?
                <PersonDetails isModalOpen={isPersonModalOpen} person={person} handleModalShow={handlePersonModalShow}/> : ''
            }
        </div>
    )
};

export default EarthHeader;